import { NgClass, NgTemplateOutlet, TitleCasePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { TranslateModule } from "@ngx-translate/core";
import { TilbyGesturesDirective } from "@tilby/tilby-ui-lib/directives/tilby-gestures";
import { GeneralInputButton } from "@tilby/tilby-ui-lib/models";
import { TilbyCurrencyPipe } from "@tilby/tilby-ui-lib/pipes/tilby-currency";
import { TilbyDatePipe } from "@tilby/tilby-ui-lib/pipes/tilby-date";
import { Sales } from "tilby-models";

@Component({
    selector: "app-active-sale-header-info-v2",
    templateUrl: "./active-sale-header-info-v2.component.html",
    standalone: true,
    imports: [NgTemplateOutlet, TitleCasePipe, MatIconModule, MatMenuModule, TranslateModule, TilbyCurrencyPipe, TilbyDatePipe, TilbyGesturesDirective, NgClass],
    host: {
        class: "tw-box-border tw-flex tw-flex-col tw-gap-1 tw-mb-1 tw-rounded-2xl tw-bg-[var(--sys-cashregister-cart-head-bg)] tw-p-1 tw-text-[var(--sys-text)]"
    }
})
export class ActiveSaleHeaderInfoV2Component implements OnChanges {
    @Input() sale: Sales | undefined;
    @Input() disableActions = false;
    @Input() isTableNameOnTopBar = false;
    @Input() accessibility = false;
    @Input() deselectSalesFromMenuBar = false;
    @Input() isOrderPrinterPermitted = true;
    @Input() isHidePrices = false;
    @Input() showPreBill = true;
    @Input() showSaleFinalAmount = false;
    @Input() isPaymentsState = false;
    @Input() contextMenu: GeneralInputButton[] = [];
    @Input() documentData: any = null;
    @Output() addCustomerActionEvent = new EventEmitter<void>();
    @Output() removeCustomerActionEvent = new EventEmitter<void>();
    @Output() preBillActionEvent = new EventEmitter<void>();
    @Output() saleChangeNameActionEvent = new EventEmitter<void>();
    @Output() openOrderPrinterSelectActionEvent = new EventEmitter<void>();
    @Output() selectSaleActionEvent = new EventEmitter<void>();
    @Output() deselectSaleActionEvent = new EventEmitter<void>();

    protected customerLabel: string | undefined;
    protected formattedDateCreatedAt: string | undefined;
    protected formattedDateDeliverAt: string | undefined;
    protected readonly isMobile = typeof navigator !== "undefined"
        ? /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
        : false;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["sale"] && (changes["sale"].currentValue || changes["sale"].currentValue === undefined)) {
            this.customerLabel = this.getCustomerLabel(this.sale) || undefined;
            this.formattedDateCreatedAt = this.dateFormat(this.sale?.created_at);
            this.formattedDateDeliverAt = this.dateFormat(this.sale?.deliver_at);
        }
    }

    protected removeCustomerAction(): void {
        if (this.customerLabel) {
            this.removeCustomerActionEvent.emit();
        }
    }

    protected getExternalId(externalId: string): string {
        return externalId.length > 10 ? externalId.substring(0, 10) + "..." : externalId;
    }

    private getCustomerLabel(sale?: Sales): string | undefined {
        if (!sale) {
            return undefined;
        } else if (sale.sale_customer?.first_name && sale.sale_customer?.last_name) {
            return `${sale.sale_customer.first_name} ${sale.sale_customer.last_name}`;
        } else if (sale.sale_customer?.company_name) {
            return sale.sale_customer.company_name;
        } else if (sale.customer_tax_code) {
            return sale.customer_tax_code;
        }
        return undefined;
    }

    private dateFormat(date: string | Date | undefined): string | undefined {
        if (!date) {
            return undefined;
        }
        const dateSale = TilbyDatePipe.shopDate({ date });
        const dateNow = TilbyDatePipe.shopDate();
        return dateSale?.substring(0, 10) === dateNow?.substring(0, 10) ? "HH:mm" : "HH:mm dd/MM";
    }
}
